import React, { useState } from "react";
import "../componnetsCss/Home.css"
import { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import {
  FaHatWizard,
  FaWhatsapp,
  FaPhone,
  FaPhoneAlt,
  FaWallet,
  FaShieldAlt,
  FaPlusCircle,
  FaLock,
  FaCheckCircle
} from "react-icons/fa";
import Carousel from "react-bootstrap/Carousel";
import { Link, Route, Router, Routes, useLocation } from "react-router-dom";
import firstImg from "../images/asda.jpg";
import ThreeHunbdred from "../images/300.png";
import fiveHundred from "../images/500.png";
import { Button, Col, Row } from "react-bootstrap";
import { getDatabase, ref, onValue, update } from "firebase/database";
import { app } from "../Firebase";
import Alert from "react-bootstrap/Alert";
import ReactPlayer from "react-player";
import Card from "react-bootstrap/Card";
import Placeholder from "react-bootstrap/Placeholder";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import Packs from "./Packs";
import Withdrewl from "./Withdrewl";
import ContactUs from "./ContactUs";
import GiveawayParti from "./GiveawayParti";

const Home = () => {
  const [showBal, setBal] = useState(Number);
  const [showUserName, setshowUserName] = useState();
  /////// UserId
  const [userid, SetUserId] = useState();
  console.log(userid);
  ////// for package 1  after buy botton msg
  const [showbtnmsg, Setshowbtnmsg] = useState();
  /////// for collect button
  const [pack1CollMgs, setChk] = useState(false);
  /////// for video show hide
  const [videoShowForPack1, Setvideoshowforpack] = useState();
  ///// For Colect button Show Hide
  const [showCollect, SetshowCollect] = useState(1);
  ////// For pack 1 video url
  const [videoPack1Url, setvideoPack1Url] = useState(); //package 1 video Url
  ///////////////////////// For Pack 2
  ////////For Btn Show Hide
  const [showbtnmsgpk2, setshowbtnmsgpkb] = useState(false);
  ////////For video Show Hide For Package 2
  const [videoShowForPack2, setvideoShowForPack2] = useState();
  /////// For Collect Botton For Package 2
  const [pack2CollMsg, setpack2CollMsg] = useState(false);
  ///// For Colect button Show Hide
  const [showCollectPack2, setshowCollectPack2] = useState(1);

  const [videoUrlPack2, setvideoUrlPack2] = useState(); /// package  2 video url lick
  const [devMsg, setdevMsg] = useState();


  const activities = [
    "Ali Khan earned RS 250 confirm watching video",
    "Zeeshan just withdrew RS 1,200 via EasyPaisa",
    "Sara Ahmed upgraded to Package 1",
    "Usman Ahmed earned RS 180 confirm watching video",
    "Hamza just upgraded to Package 2",
    "Ayesha withdrew RS 2,500 via JazzCash",
    "Bilal Siddiqui earned RS 350 confirm watching video",
    "Sana Malik upgraded to Package 3",
    "Omer Farooq earned RS 120 confirm watching video",
    "Maria Khan withdrew RS 4,800 via Bank Transfer",
    "Fahad Mustafa earned RS 500 confirm watching video",
    "Raza Ali upgraded to Package 1",
    "Nida Sheikh earned RS 210 confirm watching video",
    "Kashif Jameel withdrew RS 950 via EasyPaisa",
    "Hina Pervez earned RS 400 confirm watching video",
    "Tanveer Ahmed upgraded to Package 2",
    "Zainab Bibi earned RS 150 confirm watching video",
    "Waqas Khan withdrew RS 3,200 via JazzCash",
    "Asma Gull earned RS 280 confirm watching video",
    "Adnan Malik upgraded to Package 1",
    "Shoaib Akhtar earned RS 600 confirm watching video",
    "Mehak Jan withdrew RS 1,500 via EasyPaisa",
    "Farhan Saeed upgraded to Package 3",
    "Iqra Aziz earned RS 220 confirm watching video",
    "Salman Shah deposited RS 500 for Package 1",
    "Tayyaba Khan upgraded to Package 2",
    "Haris Rauf earned RS 450 confirm watching video",
    "Nimra Ahmed withdrew RS 2,200 via JazzCash",
    "Junaid Khan earned RS 190 confirm watching video",
    "Babar Azam upgraded to Package 1",
    "Saba Qamar earned RS 310 confirm watching video",
    "Muneeb Butt withdrew RS 5,000 via EasyPaisa",
    "Arsalan Ash earned RS 240 confirm watching video",
    "Kubra Khan upgraded to Package 3",
    "Danish Taimoor earned RS 170 confirm watching video",
    "Fiza Ali withdrew RS 1,800 via Bank Transfer",
    "Imran Abbas upgraded to Package 1",
    "Maya Ali earned RS 420 confirm watching video",
    "Shehryar Munawar deposited RS 1,000 for Package 2",
    "Sajal Aly upgraded to Package 2",
    "Ahad Raza Mir earned RS 130 confirm watching video",
    "Yumna Zaidi withdrew RS 2,900 via EasyPaisa",
    "Bilal Abbas upgraded to Package 3",
    "Sanam Saeed earned RS 380 confirm watching video",
    "Fawad Khan withdrew RS 4,500 via JazzCash",
    "Mahira Khan upgraded to Package 1",
    "Ushna Shah earned RS 260 confirm watching video",
    "Gohar Rasheed withdrew RS 1,100 via EasyPaisa",
    "Sana Javed upgraded to Package 2",
    "Mikaal Zulfiqar earned RS 550 confirm watching video",
    "Adeel Hussain earned RS 290 confirm watching video",
    "Kiran Haq just withdrew RS 2,000 via EasyPaisa",
    "Feroze Khan upgraded to Package 3",
    "Sana Khan earned RS 140 confirm watching video",
    "Madiha Imam just upgraded to Package 1",
    "Azfar Rehman withdrew RS 3,400 via JazzCash",
    "Soniya Hussain earned RS 470 confirm watching video",
    "Asad Siddiqui upgraded to Package 2",
    "Yasir Hussain earned RS 110 confirm watching video",
    "Iqra Aziz withdrew RS 6,000 via Bank Transfer",
    "Agha Ali earned RS 520 confirm watching video",
    "Hina Altaf upgraded to Package 1",
    "Sami Khan earned RS 230 confirm watching video",
    "Zahid Ahmed withdrew RS 850 via EasyPaisa",
    "Minal Khan earned RS 410 confirm watching video",
    "Aiman Khan upgraded to Package 3",
    "Amna Ilyas earned RS 160 confirm watching video",
    "Sheheryar Munawar withdrew RS 3,800 via JazzCash",
    "Ramsha Khan earned RS 275 confirm watching video",
    "Affan Waheed upgraded to Package 2",
    "Sarah Khan earned RS 620 confirm watching video",
    "Noor Hassan withdrew RS 1,700 via EasyPaisa",
    "Mansha Pasha upgraded to Package 3",
    "Ali Rehman Khan earned RS 215 confirm watching video",
    "Usman Khalid deposited RS 500 for Package 1",
    "Sanam Jung upgraded to Package 2",
    "Ahmed Ali Akbar earned RS 440 confirm watching video",
    "Hareem Farooq withdrew RS 2,400 via JazzCash",
    "Azra Mohyeddin earned RS 195 confirm watching video",
    "Shabbir Jan upgraded to Package 1",
    "Rubina Ashraf earned RS 320 confirm watching video",
    "Mahmood Aslam withdrew RS 5,500 via EasyPaisa",
    "Sohai Ali Abro earned RS 245 confirm watching video",
    "Ayesha Omar upgraded to Package 3",
    "Aziz Jibran earned RS 175 confirm watching video",
    "Zeba Bakhtiar withdrew RS 1,900 via Bank Transfer",
    "Javed Sheikh upgraded to Package 1",
    "Bushra Ansari earned RS 430 confirm watching video",
    "Behroze Sabzwari deposited RS 1,000 for Package 2",
    "Shahroz Sabzwari upgraded to Package 2",
    "Syra Yousuf earned RS 135 confirm watching video",
    "Sadaf Kanwal withdrew RS 3,000 via EasyPaisa",
    "Shehroz Ahmed upgraded to Package 3",
    "Navin Waqar earned RS 390 confirm watching video",
    "Ahsan Khan withdrew RS 4,700 via JazzCash",
    "Sarwat Gilani upgraded to Package 1",
    "Nimra Khan earned RS 265 confirm watching video",
    "Zubab Rana withdrew RS 1,250 via EasyPaisa",
    "Noor Zafar Khan upgraded to Package 2",
    "Wahaj Ali earned RS 560 confirm watching video",
    "Hiba Qadir earned RS 305 confirm watching video",
    "Areeba Habib just withdrew RS 2,100 via EasyPaisa",
    "Saad Qureshi upgraded to Package 3",
    "Kinza Hashmi earned RS 155 confirm watching video",
    "Ali Ansari just upgraded to Package 1",
    "Saboor Aly withdrew RS 3,600 via JazzCash",
    "Mariyam Nafees earned RS 480 confirm watching video",
    "Gohar Mumtaz upgraded to Package 2",
    "Asim Azhar earned RS 115 confirm watching video",
    "Momina Mustehsan withdrew RS 6,200 via Bank Transfer",
    "Umair Jaswal earned RS 530 confirm watching video",
    "Sana Shahnawaz upgraded to Package 1",
    "Samina Peerzada earned RS 235 confirm watching video",
    "Usman Peerzada withdrew RS 880 via EasyPaisa",
    "Hammad Shoaib earned RS 415 confirm watching video",
    "Arisha Razi upgraded to Package 3",
    "Zain Afzal earned RS 165 confirm watching video",
    "Faizan Sheikh withdrew RS 3,900 via JazzCash",
    "Rabia Butt earned RS 285 confirm watching video",
    "Emaan Suleman upgraded to Package 2",
    "Amna Babar earned RS 630 confirm watching video",
    "Hasnain Lehri withdrew RS 1,750 via EasyPaisa",
    "Sabeeka Imam upgraded to Package 3",
    "Fouzia Aman earned RS 225 confirm watching video",
    "Shahzad Noor deposited RS 500 for Package 1",
    "Alyzeh Gabol upgraded to Package 2",
    "Sadaf Khan earned RS 445 confirm watching video",
    "Mehreen Syed withdrew RS 2,450 via JazzCash",
    "Iffat Omar earned RS 205 confirm watching video",
    "Juggun Kazim upgraded to Package 1",
    "Shaista Lodhi earned RS 325 confirm watching video",
    "Nida Pasha withdrew RS 5,600 via EasyPaisa",
    "Faysal Qureshi earned RS 255 confirm watching video",
    "Sajal Mir upgraded to Package 3",
    "Ahad Mir earned RS 185 confirm watching video",
    "Saboor Ali withdrew RS 1,950 via Bank Transfer",
    "Minal Ahsan upgraded to Package 1",
    "Aiman Muneeb earned RS 435 confirm watching video",
    "Muneeb Muneeb deposited RS 1,000 for Package 2",
    "Urwa Hocane upgraded to Package 2",
    "Farhan Saeed Mir earned RS 145 confirm watching video",
    "Mawra Hocane withdrew RS 3,100 via EasyPaisa",
    "Haroon Shahid upgraded to Package 3",
    "Ramsha Khan Ali earned RS 395 confirm watching video",
    "Bilal Saeed withdrew RS 4,800 via JazzCash",
    "Aima Baig upgraded to Package 1",
    "Sahir Ali Bagga earned RS 275 confirm watching video",
    "Nabeel Shaukat withdrew RS 1,300 via EasyPaisa",
    "Rahat Fateh Ali upgraded to Package 2",
    "Atif Aslam earned RS 570 confirm watching video",
    "Ali Zafar earned RS 315 confirm watching video",
    "Shani Arshad just withdrew RS 2,200 via EasyPaisa",
    "Hadiqa Kiani upgraded to Package 3",
    "Quratulain Balouch earned RS 165 confirm watching video",
    "Zeb Bangash just upgraded to Package 1",
    "Annie Khalid withdrew RS 3,700 via JazzCash",
    "Amanat Ali earned RS 490 confirm watching video",
    "Fariha Pervez upgraded to Package 2",
    "Humaira Arshad earned RS 125 confirm watching video",
    "Jawad Ahmed withdrew RS 6,400 via Bank Transfer",
    "Ali Azmat earned RS 540 confirm watching video",
    "Strings Band upgraded to Package 1",
    "Noori Band earned RS 245 confirm watching video",
    "Farhad Humayun withdrew RS 920 via EasyPaisa",
    "Goher Mumtaz earned RS 425 confirm watching video",
    "Mizraab Band upgraded to Package 3",
    "Call Band earned RS 175 confirm watching video",
    "Entity Paradigm withdrew RS 4,100 via JazzCash",
    "Junaid Jamshed earned RS 295 confirm watching video",
    "Vital Signs upgraded to Package 2",
    "Junoon Band earned RS 640 confirm watching video",
    "Abida Parveen withdrew RS 1,850 via EasyPaisa",
    "Nusrat Fateh Ali upgraded to Package 3",
    "Arif Lohar earned RS 235 confirm watching video",
    "Sanam Marvi deposited RS 500 for Package 1",
    "Saien Zahoor upgraded to Package 2",
    "Attaullah Khan earned RS 455 confirm watching video",
    "Mansoor Malangi withdrew RS 2,550 via JazzCash",
    "Allah Ditta earned RS 215 confirm watching video",
    "Pathanay Khan upgraded to Package 1",
    "Reshma Bibi earned RS 335 confirm watching video",
    "Zarsanga Bibi withdrew RS 5,700 via EasyPaisa",
    "Gul Panra earned RS 265 confirm watching video",
    "Hamayoon Khan upgraded to Package 3",
    "Bakhtiyar Khattak earned RS 195 confirm watching video",
    "Zeek Afridi withdrew RS 2,050 via Bank Transfer",
    "Khyal Muhammad upgraded to Package 1",
    "Rafiq Shinwari earned RS 445 confirm watching video",
    "Gulnar Bibi deposited RS 1,000 for Package 2",
    "Nagmanat Bibi upgraded to Package 2",
    "Kishwar Sultan earned RS 155 confirm watching video",
    "Munir Sarhadi withdrew RS 3,200 via EasyPaisa",
    "Ustad Nusrat upgraded to Package 3",
    "Sabri Brothers earned RS 405 confirm watching video",
    "Aziz Mian withdrew RS 4,900 via JazzCash",
    "Sher Ali Khan upgraded to Package 1",
    "Mehr Ali Khan earned RS 285 confirm watching video",
    "Badar Miandad withdrew RS 1,400 via EasyPaisa",
    "Faiz Ali Faiz upgraded to Package 2",
    "Rahat Ali earned RS 580 confirm watching video",
    "Farrukh Fateh earned RS 325 confirm watching video",
    "Dildar Pervez just withdrew RS 2,300 via EasyPaisa",
    "Mubarak Ali upgraded to Package 3",
    "Salamar Ali earned RS 175 confirm watching video",
    "Shujat Ali just upgraded to Package 1",
    "Asad Amanat withdrew RS 3,800 via JazzCash",
    "Shafqat Amanat earned RS 500 confirm watching video",
    "Hameed Ali upgraded to Package 2",
    "Fateh Ali Khan earned RS 135 confirm watching video",
    "Rustam Fateh withdrew RS 6,600 via Bank Transfer",
    "Sultan Fateh earned RS 550 confirm watching video",
    "Ustad Amanat upgraded to Package 1",
    "Ustad Bade Ghulam earned RS 255 confirm watching video",
    "Ustad Salamat withdrew RS 960 via EasyPaisa",
    "Ustad Nazakat earned RS 435 confirm watching video",
    "Ustad Shaukat upgraded to Package 3"
  ];

  const [currentText, setCurrentText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const user = location.state;

  let currentDateTime = new Date().toISOString();
  let currentDate = new Date().getDate();
  let currentHours = new Date().getHours();
  let currentMinutes = new Date().getMinutes();
  let currentSecond = new Date().getSeconds();
  useEffect(() => {
    const showNotification = () => {
      // 1. Random index pick karna
      const randomIndex = Math.floor(Math.random() * activities.length);
      setCurrentText(activities[randomIndex]);

      // 2. Show karna
      setIsVisible(true);

      // 3. 3 second baad hide karna
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    };

    // Pehli baar foran chalayein
    showNotification();

    // Har 6 second baad cycle repeat karein (3s show + 3s gap)
    const interval = setInterval(showNotification, 6000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    ////////For Exist User Data Func

    const readDataUser = () => {
      const db = getDatabase(app);
      const starCountRef = ref(db, user);
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        const assd = data.userid;
        setBal(data.Bal);
        SetUserId(assd);
        setshowUserName(data.username);
        Setshowbtnmsg(data.Msg.pack1);
        Setvideoshowforpack(data.Packages.package1);
        setvideoPack1Url(data.URL.pack1);
        ///for pack 2
        setshowbtnmsgpkb(data.Msg.pack2);
        setvideoShowForPack2(data.Packages.package2);
        setvideoUrlPack2(data.URL.pack2);
        setdevMsg(data.MsgForDeveloper);
      });
    };
    readDataUser();
  }, []);

  //// Func For Package 1
  const funcPackOne = () => {
    if (showBal >= 300) {
      const db = getDatabase(app);
      const as = ref(db, `${userid}`);
      let ass = showBal - 300;
      update(as, {
        Bal: ass,
        BuyPack1: {
          whichPackage: 300,
          andBuyTime: `date:${currentDate}=${currentHours}:${currentMinutes}:${currentSecond}`,
        },
      })
        .then((ref) => {
          const notify = () => toast.success("Package Buy Successfully");
          notify();
          console.log(1);
        })
        .catch((err) => {
          const notify = () => toast.warn("Please Deposit");
          notify();
        });

      /////for hide botton if user buy this package
      const aas = ref(db, `${userid}/Msg`);
      update(aas, {
        pack1: true,
      });

      return false;
    } else {
      toast.warn("Please Deposit");
      console.log(`bye`);
    }
  };

  //// Simple Small Function for pack1
  const pack1FuncForColl = () => {
    setTimeout(() => {
      setChk(true);
    }, 120000);
  };

  const collPack1Coin = () => {
    SetshowCollect(showCollect + 1);
    const db = getDatabase(app);
    const aas = ref(db, `${userid}`);
    const a = showBal + 40;
    update(aas, {
      Bal: a,
    });

    setChk(false);
    Setvideoshowforpack(false);
    setChk(false);

    const aaas = ref(db, `${userid}/Packages`);

    // const collect = showBal + 50;

    update(aaas, {
      package1: false,
      pkg1: `${currentDate}/ ${currentHours}/h.. ${currentMinutes}/m.. ${currentSecond}/s..`,
    });
  };

  /////////////////////Function For Package2
  const funcPack2ForBuy = () => {
    if (showBal >= 500) {
      const db = getDatabase(app);
      const as = ref(db, `${userid}`);
      let ass = showBal - 500;
      update(as, {
        Bal: ass,
        BuyPack2: {
          whichPackage2: 500,
          andBuyTime2: `date:${currentDate}=${currentHours}:${currentMinutes}:${currentSecond}`,
        },
      })
        .then((ref) => {
          const notify = () => toast.success("Package Buy Successfully");
          notify();
          console.log(1);
        })
        .catch((err) => {
          const notify = () => toast.warn("Please Deposit");
          notify();
        });
      /////for hide botton if user buy this package
      const aas = ref(db, `${userid}/Msg`);
      update(aas, {
        pack2: true,
      });

      return false;
    } else {
      toast.warn("Please Deposit");
    }
  };
  ///////// For onStart Func in Package 2

  const pack2FuncForColl = () => {
    setTimeout(() => {
      setpack2CollMsg(true);
    }, 900000);
  };
  const collPack2Coin = () => {
    setshowCollectPack2(showCollectPack2 + 1);
    const db = getDatabase(app);
    const aas = ref(db, `${userid}`);
    const a = showBal + 66;
    update(aas, {
      Bal: a,
    });

    setpack2CollMsg(false);
    setvideoShowForPack2(false);
    setpack2CollMsg(false);

    const aaas = ref(db, `${userid}/Packages`);

    update(aaas, {
      package2: false,
      pkg2: `${currentDate}/ ${currentHours}/h.. ${currentMinutes}/m.. ${currentSecond}/s..`,
    });
  };

  return (
    <div className="fintech-dashboard">
      <ToastContainer position="top-right" autoClose={1000} theme="light" />

      {/* Fixed Header */}
      <header className="fintech-nav">
        <div className="nav-wrapper">
          <Link className="fintech-logo" to="/home">
            <div className="logo-glow"></div>
            <span className="logo-text">Earning</span>
            <span className="blue-dot">HUB</span>
          </Link>

          <nav className="nav-actions">
            <Link className="action-link withdraw-glass" to="/withdrewl" state={{ name: user }}>
              <FaWallet className="nav-icon" />
              <span className="link-text">Withdraw</span>
            </Link>
            <Link className="action-link support-neon" to="/contactus">
              <FaWhatsapp className="nav-icon pulse-icon" />
              <span className="link-text">Contact Us</span>
            </Link>
          </nav>
        </div>
      </header>

      {/* Dashboard Content - Yahan padding fix ki hai */}
      <main className="dashboard-body">

        {/* Welcome & Balance Main Block */}
        <section className="premium-stats-container">
          <div className="trusted-main-card">
            <div className="card-top-header">
              <div className="user-identity">
                <div className="avatar-shield">
                  <span className="user-initial">{showUserName?.charAt(0)}</span>
                  <div className="verified-check">✓</div>
                </div>
                <div className="identity-text">
                  <span className="greeting-sub">Assalam o Alaikum</span>
                  <h3 className="user-display-name">{showUserName}</h3>
                </div>
              </div>
              <div className="secure-badge">
                <FaShieldAlt className="shield-icon" />
                <span>Secure</span>
              </div>
            </div>

            <div className="announcement-wrapper">
              <div className="announcement-bar">
                {/* Side Tag */}
                <div className="live-tag-container">
                  <span className="live-dot"></span>
                  <span className="live-tag">NEWS</span>
                </div>

                {/* Text Area */}
                <div className="msg-container">
                  <div className="scrolling-msg glow-text">
                    <span>{devMsg}</span>
                    <span>{devMsg}</span> {/* Repeat for seamless loop */}
                  </div>
                </div>
              </div>
            </div>

            <div className="financial-grid">
              <div className="balance-info-box">
                <span className="finance-label">Available Balance</span>
                <div className="balance-amount-row">
                  <span className="currency-symbol">Rs.</span>
                  <h2 className="main-balance">{showBal}</h2>
                </div>
              </div>
              <div className="action-button-area">
                <Link to="/deposit" state={{ value: showBal, showUserName, userid }} className="deposit-link">
                  <button className="premium-deposit-btn">
                    <FaPlusCircle className="btn-icon" />
                    <span>Deposit</span>
                  </button>
                </Link>
              </div>
            </div>
            <div className="dynamic-box-wrapper">
              <div className={`dynamic-pill ${isVisible ? 'active' : 'hidden'}`}>
                <div className="live-dot"></div>
                <span className="pill-text">{currentText}</span>
              </div>
            </div>
            <div className="card-trust-footer">
              <div className="trust-item"><FaLock className="trust-icon" /> <span>Encrypted</span></div>
              <div className="trust-item"><FaCheckCircle className="trust-icon" /> <span>Instant</span></div>
            </div>
          </div>
        </section>

        <div className="section-header-wrapper">
          <div className="title-container">
            <div className="line-decorator"></div>
            <h2 className="section-title">

              Investment Packages
              <span className="live-status-pulse"></span>
            </h2>
            <p className="section-subtitle">Choose a plan to start your earning journey</p>
          </div>
        </div>

        {/* Packages Grid */}
        <section className="packages-container">
          {/* Package Grid Wrapper */}
          <div className="packages-wrapper">

            {/* Package 1 */}
            <div className="premium-card">
              <div className="card-media-box">
                {videoShowForPack1 ? (
                  <div className="player-wrapper">
                    <ReactPlayer
                      url={videoPack1Url}
                      className="react-player"
                      width="100%"
                      height="100%"
                      onStart={pack1FuncForColl}
                    />
                  </div>
                ) : (
                  <div className="image-wrapper">
                    <img src={ThreeHunbdred} alt="300 Package" className="package-img" />
                  </div>
                )}
                <div className="package-badge">Popular</div>
              </div>

              <div className="card-body-content">
                <h3 className="pkg-title">Basic Node: <span className="price">300Rs</span></h3>
                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Total Return:</span> <strong>1200 Rs</strong>
                  </div>
                  <div className="stat-row">
                    <span>Video 1:</span> <strong>10:30 - 11:00am</strong>
                  </div>
                  <div className="stat-row">
                    <span>Video 2:</span> <strong>11:00 - 11:30am</strong>
                  </div>
                  <div className="stat-row">
                    <span>Duration:</span> <strong>2 Minutes</strong>
                  </div>
                  <div className="validity-tag">Validity: 15 Days</div>
                </div>

                <div className="card-action-box">
                  {showbtnmsg ? (
                    <div className="collect-wrapper">
                      {pack1CollMgs ? (
                        <button className="collect-btn" onClick={collPack1Coin}>Collect Now</button>
                      ) : (
                        <span className="waiting-status">⏳ Waiting...</span>
                      )}
                    </div>
                  ) : (
                    <button className="buy-btn" onClick={funcPackOne}>Buy Package</button>
                  )}
                </div>
              </div>
            </div>

            {/* Package 2 */}
            <div className="premium-card">
              <div className="card-media-box">
                {videoShowForPack2 ? (
                  <div className="player-wrapper">
                    <ReactPlayer
                      url={videoUrlPack2}
                      className="react-player"
                      width="100%"
                      height="100%"
                      onStart={pack2FuncForColl}
                    />
                  </div>
                ) : (
                  <div className="image-wrapper">
                    <img src={fiveHundred} alt="500 Package" className="package-img" />
                  </div>
                )}
                <div className="package-badge gold">Best Value</div>
              </div>

              <div className="card-body-content">
                <h3 className="pkg-title">Pro Node: <span className="price">500Rs</span></h3>
                <div className="pkg-stats">
                  <div className="stat-row highlight">
                    <span>Total Return:</span> <strong>2000 Rs</strong>
                  </div>
                  <div className="stat-row">
                    <span>Video 1:</span> <strong>10:30 - 11:00am</strong>
                  </div>
                  <div className="stat-row">
                    <span>Video 2:</span> <strong>11:00 - 11:30am</strong>
                  </div>
                  <div className="stat-row">
                    <span>Duration:</span> <strong>15 Minutes</strong>
                  </div>
                  <div className="validity-tag">Validity: 15 Days</div>
                </div>

                <div className="card-action-box">
                  {showbtnmsgpk2 ? (
                    <div className="collect-wrapper">
                      {pack2CollMsg ? (
                        <button className="collect-btn" onClick={collPack2Coin}>Collect Now</button>
                      ) : (
                        <span className="waiting-status">⏳ Waiting...</span>
                      )}
                    </div>
                  ) : (
                    <button className="buy-btn" onClick={funcPack2ForBuy}>Buy Package</button>
                  )}
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>

      <Packs value={{ user }} />
    </div>
  );
};

export default Home;
